(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($) {
  // Set cookies when clicking 'Search' button
  $("#wpsl-search-btn").mouseup(function () {
    setCookieAsCategoryIds();
  }); // Set cookies when 'Enter' key is pressed on the form

  $('#wpsl-search-wrap').keyup(function (event) {
    if (event.which === 13 || event.keyCode === 13) {
      setCookieAsCategoryIds();
    }
  });
  /**
   * Set the cookie to the value of the selected Category Filter.
   * Check if the filter is displayed as dropdown or checkbox and get the selected values.
   */

  function setCookieAsCategoryIds() {
    // same as in wp_store_locator: /wp-store-locator/js/wpsl-gmap.js - collectAjaxData()
    var isMobile = $("#wpsl-wrap").hasClass("wpsl-mobile");
    var categoryId = 0;
    var categoryIds = 0;

    if ($("#wpsl-category").length > 0) {
      if (isMobile) {
        categoryId = parseInt($("#wpsl-category .wpsl-dropdown").val());
      } else {
        categoryId = parseInt($("#wpsl-category .wpsl-selected-item").attr("data-value"));
      }

      if (!isNaN(categoryId) && categoryId !== 0) {
        categoryIds = categoryId;
      }
    } else if ($("#wpsl-checkbox-filter").length > 0) {
      if ($("#wpsl-checkbox-filter input:checked").length > 0) {
        categoryIds = getCheckboxIds();
      }
    } // 'lsl-map-category-id' cookie is set and used in the query to display the stores for the selected category


    document.cookie = 'lsl-map-category-id=' + categoryIds + '; path=/';
  } // same as in wp_store_locator: /wp-store-locator/js/wpsl-gmap.js - getCheckboxIds()


  function getCheckboxIds() {
    var catIds = $("#wpsl-checkbox-filter input:checked").map(function () {
      return $(this).val();
    });
    catIds = catIds.get();
    catIds = catIds.join(',');
    return catIds;
  }
})(jQuery);

},{}]},{},[1]);
